import { render, staticRenderFns } from "./ShareWeChat.vue?vue&type=template&id=0771208a&scoped=true&"
import script from "./ShareWeChat.vue?vue&type=script&lang=js&"
export * from "./ShareWeChat.vue?vue&type=script&lang=js&"
import style0 from "./ShareWeChat.vue?vue&type=style&index=0&id=0771208a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771208a",
  null
  
)

export default component.exports